





















































import Vue from "vue";
import axios from "axios";
import VariableInput from "@/components/util/VariableInput.vue";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import { checkUserId, signUp } from "@/api/Login";
import { authPhoneNumberConstraintErrorMessage, authPhoneNumberLengthLimit, authPhoneNumberRegExp } from "./constraint";
import { ErrorResponse } from "@/api/dto/Error";
import { validate } from "../../api/Login";
import { checkDuplicatePhoneNumber, createAuthCode } from "@/api/UserProfile";
import { getUserIdFromId } from "../../api/UserProfile";

export default Vue.extend({
  name: "Signup",
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    /**
     * 入力値変更時にバリデーション
     */
    "accountData.authPhoneNumber"(authPhoneNumber: string) {
          this.checkPhoneNumber();
    },
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(
        this.accountData.authPhoneNumber.length <= authPhoneNumberLengthLimit && 
        authPhoneNumberRegExp.test(this.accountData.authPhoneNumber) &&
        !this.isDapulicate
      );
    },
  },
  data() {
    return {
      accountData: {
        authPhoneNumber: "",
      },
      signupInputs: {
        authPhoneNumber: {
          name: "電話番号",
          type: "text",
          placeholder: "電話番号",
          constraint: authPhoneNumberConstraintErrorMessage,
          error: "",
          ok: "",
        },
      },
      isValidate: false,
      message: "",
      submitModal: false,
      isDapulicate: false,
    };
  },
  async created() {
    try {
      var id = this.$route.params.id.toString();
      var res = await validate(id);
      if (res.isValidate == false) {
        this.isValidate = false;
        this.message = res.message;
      }
    } catch (e) {
      this.isValidate = false;
    }
  },
  methods: {
    async onClickSignUp() {
      try {
        // SMS送信
        await createAuthCode({
          userId: this.$route.params.id,
          phoneNumber: this.accountData.authPhoneNumber,
          purpose: "新規会員登録",
        });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit("errorToast", resError.message);
          }
          return;
        }
      }
      // 番号認証画面に遷移する
      this.$router.push({
        name: "SignupNumberAuthentication",
        params: {
          id: this.$route.params.id, // アカウントID
          phoneNumber: this.accountData.authPhoneNumber, // 電話番号
        },
      });
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit("pushPath", path);
    },
/**
 * 電話番号の重複チェックをし, それに応じたメッセージを設定する
 */
    async checkPhoneNumber() {
      if (!authPhoneNumberRegExp.test(this.accountData.authPhoneNumber)) {
        this.signupInputs["authPhoneNumber"].ok = "";
      this.signupInputs["authPhoneNumber"].error =
        authPhoneNumberRegExp.test(this.accountData.authPhoneNumber) && this.accountData.authPhoneNumber.length <= authPhoneNumberLengthLimit
          ? ""
          : authPhoneNumberConstraintErrorMessage;
        return;
      }
      const res = await checkDuplicatePhoneNumber({
        userId: this.$route.params.id,
        inputPhoneNumber: this.accountData.authPhoneNumber,
       });

      if (res.isDuplicate) {
        this.signupInputs["authPhoneNumber"].error = res.message;
        this.isDapulicate = true;
      } else {
        this.signupInputs["authPhoneNumber"].error = '';
        this.signupInputs["authPhoneNumber"].ok = res.message;
        this.isDapulicate = false;
      }
    },
    /**
     * 認証コードを送信する
     */
    async sendAuthCode() {
      try {
        await createAuthCode({
          userId: this.$route.params.id,
          phoneNumber: this.accountData.authPhoneNumber,
          purpose: "新規会員登録",
        });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit("errorToast", resError.message);
          }
        }
      }
      this.$emit("toast", "認証コードを送信しました。");
    },
  },
});
